module.exports = __webpack_public_path__ + "img/cover.73200c10.jpg";